module.exports = __webpack_public_path__ + "static/media/doctor-portrait.7675964f.png";